import { Contact } from '@plug-core/interfaces/common'
import { ListGroup } from '@ui'
import React from 'react'
import { ContactListItem } from './ContactListItem'

export interface IProps {
  contacts: Contact[]
  onContactClick: (contact: Contact) => void
  hideDeleteButton?: boolean
}

export const ContactList = ({ contacts, onContactClick, hideDeleteButton }: IProps) =>
  contacts.length ? (
    <ListGroup>
      {contacts.map((contact) => (
        <ContactListItem
          key={contact.id}
          contact={contact}
          onClick={onContactClick}
          hideDeleteButton={!!hideDeleteButton}
        />
      ))}
    </ListGroup>
  ) : null
